import { Component, HostListener, inject, OnInit } from '@angular/core';
import { OutcomesService } from './outcomes.service';
import { decodeBase64ToText, encodeToBase64 } from '../../utility';
import {
  Filter,
  FilterGroup,
  FilterTemplate,
  Template,
} from './outcomes-interface';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UploadComponent } from './upload/upload.component';
import { SyncComponent } from './sync/sync.component';
import { HelperService } from '../../shared/services/helper.service';
import { ToastService } from '../../shared/services/toast.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-outcomes',
  templateUrl: './outcomes.component.html',
  styleUrl: './outcomes.component.css',
})
export class OutcomesComponent implements OnInit {
  templateListUrl = `${environment.opbBackendHost}/api/admin/outcome/templates`;

  isLoading: boolean = false;
  template: any = [];
  scrollHeight: string;
  reqData: any = {
    start: '0',
    search: '', // optional
    group_id: '', // optional
    designation: '', // optional
    type: '', // optional individual, team, affiliate, teamparent
    year: '', // optional
    theme_id: '',
  };
  yearFilter: Filter[] = [];
  templateFilter: any[] = [
    { label: 'All', value: '' },
    { label: 'Individual', value: 'individual' },
    { label: 'Team', value: 'team' },
    { label: 'Affiliate', value: 'affiliate' },
    { label: 'Teamparent', value: 'teamparent' },
  ];
  groupFilter: any[] = [];
  designationFilter: Filter[] = [];
  ref: DynamicDialogRef | undefined;
  private outcomesService = inject(OutcomesService);
  private toast = inject(ToastService);

  public dialogService = inject(DialogService);
  helper = inject(HelperService);
  templateListPayload: any;
  isDownloading: boolean = false;
  isTemplateLoading: boolean = false;
  yearList: { key: number; value: number }[];
  businessThemes: Filter[] = [];
  selectedGroup: any = {};
  selectedDesignation: any = {};

  ngOnInit(): void {
    this.yearList = this.helper.generateYearArray(2022);
    this.reqData.year = new Date().getFullYear();
    this.getDesignations();
    this.getGroupsList();
    this.templatesList(this.reqData);
    this.calculateScrollHeight();
    this.getBusinessThemes(this.reqData.year);
  }

  @HostListener('window:resize', ['$event'])
  onResize($event: any) {
    this.calculateScrollHeight();
  }

  private calculateScrollHeight() {
    const headerHeight = 400;
    const footerHeight = 50;
    const windowHeight = window.innerHeight;
    this.scrollHeight = `${windowHeight - headerHeight - footerHeight}px`;
  }

  getGroupsList(search?: any) {
    const payload = { type: 'all', link: 'all', search };
    this.outcomesService.getGroups(payload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const group = parsedData.data || [];

          this.groupFilter=group;

          let newItem1: any = { group_id: '', name: 'All Groups' };
          this.groupFilter.unshift(newItem1);

          if (!this.reqData.group_id) {
            this.reqData.group_id = '';
          } else {
            if (this.groupFilter.filter(x => x.group_id == this.selectedGroup.group_id).length == 0) {
              this.groupFilter.unshift(this.selectedGroup);
              this.reqData.group_id = this.selectedGroup.group_id;
            }
          }
          
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  getDesignations(search?: any) {
    let currentSelection= this.reqData.designation
    this.outcomesService.getDesignations({ search }).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const designation = parsedData.data || [];

          this.designationFilter = designation.map((item: any) => ({
            label: item.designation,
            value: item.designation,
          }));

          let newItem1: any = { label: 'All Designations', value: '' };
          let newItem2: any = { label: 'IEL', value: 'iel' };

          // Use unshift() to add it at the beginning of the array
          this.designationFilter.unshift(newItem1, newItem2);

          if (!this.reqData.designation) {
            this.reqData.designation = '';
          } else {
            if (this.designationFilter.filter(x => x.value == this.selectedDesignation.value).length == 0) {
              this.designationFilter.unshift(this.selectedDesignation);
              this.reqData.designation = this.selectedDesignation.value;
            }
          }
          
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  getBusinessThemes(year?: any) {
    this.outcomesService.getBusinessThemes({ year }).subscribe(
      (data: any) => {
        try {
          this.businessThemes = data.data;

          let newItem1: any = { theme_id: '', value: 'All Themes' };

          // Use unshift() to aDd it at the beginning of the array
          this.businessThemes.unshift(newItem1);
          this.reqData.theme_id = '';
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  yearsList() {
    this.outcomesService.getYears({}).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const years = parsedData.data || [];

          this.yearFilter = years.map((item: any) => ({
            label: item.year,
            value: item.year,
          }));

          let newItem: any = { label: 'All Years', value: -1 };

          // Use unshift() to aDd it at the beginning of the array
          this.yearFilter.unshift(newItem);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }
  templatesList(reqData: any) {
    this.isTemplateLoading = true;
    this.templateListPayload = reqData;
    this.outcomesService.getTemplates(reqData).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.template = parsedData.data || [];
          const uniqueTemplate = [
            ...new Set(parsedData.data?.map((item: any) => item?.type)),
          ];
          const uniqueGroup = [
            ...new Set(parsedData?.data?.map((item: any) => item?.group?.type)),
          ];
          // const uniqueDesignation = [...new Set(parsedData.data.map((item: any) => item.designation))];

          // this.templateFilter= this.filterDataSet(uniqueTemplate);
          // this.groupFilter= this.filterDataSet(uniqueGroup);
          //this.designationFilter = this.filterDataSet(uniqueDesignation);
          this.isTemplateLoading = false;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
          this.isTemplateLoading = false;
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  onFilterChange(field: string, value: any, event?: any, dropdown?: any) {
    if (value == -1) {
      this.reqData[field] = '';
    } else {
      this.reqData[field] = value;
    }
    this.templatesList(this.reqData);
    if (field == 'year') {
      this.getBusinessThemes(this.reqData.year);
    }

    if (field == 'group_id') {
      this.selectedGroup = this.groupFilter.filter(x => x.group_id == value)[0];
      this.selectedGroup = { group_id: this.selectedGroup.group_id, name: this.selectedGroup.name };
      this.helper.clearDropdownFilter(dropdown);
    }

    if (field == 'designation') {
      this.selectedDesignation = this.designationFilter.filter(x => x.value == value)[0];
      this.selectedDesignation = { label: this.selectedDesignation.label, value: this.selectedDesignation.value };
      this.helper.clearDropdownFilter(dropdown);
    }
  }

  onDataLoaded(data: any) {
    this.template = data || [];
  }


  templateDownload() {
    this.isDownloading = true;
    const reqData = {
      start: '0',
      search: '', // optional
      group_id: '', // optional
      designation: '', // optional
      type: '', // optional individual, team, affiliate, teamparent
      year: this.templateListPayload.year, // optional
      responseType: 'blob',
    };

    this.outcomesService.downloadTemplate(reqData).subscribe(
      (data: Blob) => {
        this.isDownloading = false;
        const blob = new Blob([data], { type: data.type });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'template.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.toast.success('File downloaded successfully');
      },
      (error) => {
        this.isDownloading = false;
        console.error('Error fetching template:', error);
      }
    );
  }

  filterDataSet(data: any) {
    return data.map(
      (item: any) =>
        ({
          label: item,
          value: item,
        } as Filter)
    );
  }

  upload() {
    this.ref = this.dialogService.open(UploadComponent, {
      width: '40%',
      contentStyle: { 'max-height': '40vh', overflow: 'auto' },
      baseZIndex: 10000,
    });
  }

  sync() {
    this.ref = this.dialogService.open(SyncComponent, {
      width: '800px',
      height: '350px',
      styleClass:"sync-component",
      contentStyle: { 'max-height': '40vh', overflow: 'auto' },
      baseZIndex: 10000,
    });
  }

  onDesignationSearch(event: any) {
    this.getDesignations(event?.filter);
  }

  onGroupSearch(event: any) {
    this.getGroupsList(event?.filter);
  }
}
